// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"fileAddButton_buttonsContainer__UhPWN"};